/**
 * Created by harry.preiss on 22 Jun 2020
 */

import {Action, Module, Mutation} from 'vuex-module-decorators'
import store, {alertModule, currentUserModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import InstituteDto = MdbsCore.InstituteDto;
import IInstituteCreateDto = MdbsCore.IInstituteCreateDto;
import InstituteCreateDto = MdbsCore.InstituteCreateDto;
import IInstituteUpdateDto = MdbsCore.IInstituteUpdateDto;
import InstituteUpdateDto = MdbsCore.InstituteUpdateDto;
import Rights = MdbsCore.Rights;
import IInstituteDto = MdbsCore.IInstituteDto;
import InstituteCompleteDto = MdbsCore.InstituteCompleteDto;

const instituteClient = new MdbsCore.InstituteClient();

@Module({namespaced: true, name: 'institute', store: store})
export default class InstituteModule extends BaseModule {
    _currentInstitute: IInstituteDto = new MdbsCore.InstituteDto();

    _institutes: Array<InstituteDto> = [];

    get institutes(): Array<IInstituteDto> {
        return this._institutes;
    }

    get assignedUserIds() {
        return (instituteId: string) => {
            const institute = this
                .institutes
                .find(i => i.id === instituteId);

            if (!institute?.users) {
                return new Array<string>();
            }

            return institute.users;
        }
    }

    @Mutation
    setCurrentInstitute(institute: IInstituteDto) {
        this._currentInstitute = institute;
    }

    @Mutation
    setInstitutes(institutes: Array<InstituteDto>) {
        this._institutes.updateValues(institutes);
    }

    @Mutation
    reset() {
        this._institutes.clear();
    }

    @Action({rawError: true})
    async loadAll() {
        await this.execute(async () => {
                if (currentUserModule.hasRight(Rights.InstituteGetAllCmd)) {
                    this.setInstitutes(await instituteClient.getAll(false))
                } else {
                    this.setInstitutes(await instituteClient.getMy(false))
                }
            }
        ).catch(() => this.reset());
    }

    @Action({rawError: true})
    async getAllComplete() {
        let institutes = new Array<InstituteCompleteDto>();
        await this.execute(async () =>
            institutes = await instituteClient.getAllComplete(false)
        ).catch(() => {
        });

        return institutes
    }

    @Action({rawError: true})
    async createInstitute(institute: IInstituteCreateDto) {
        this.startLoading();
        try {
            await instituteClient.create(new InstituteCreateDto(institute));
            await this.loadAll()
        } catch (e) {
            console.error("institute: create", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async loadInstituteById(instituteId: string) {
        await this.execute(async () => {
            const institute = await instituteClient.getInstitute(instituteId);
            this.setCurrentInstitute(institute);
        });

        return this._currentInstitute;
    }

    @Action({rawError: true})
    async updateInstitute(institute: IInstituteUpdateDto) {
        this.startLoading();
        try {
            await instituteClient.update(institute.id, new InstituteUpdateDto(institute));
            await this.loadAll()
        } catch (e) {
            console.error("institute: update", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }
}
